export default "__VITE_ASSET__BK3Ex_Y9__"